import React from 'react';

interface SyfoAdminIconProps {
  className?: string;
  size?: number;
}

/**
 * SYFO Admin Icon
 * An orange-yellow hued icon for the Sort Your Finances Out
 * Administration connsole.
 */
export const SyfoAdminIcon: React.FC<SyfoAdminIconProps> = ({ 
  className = "", 
  size 
}) => {
  const sizeProps = size ? { width: size, height: size } : {};
  
  return (
    <svg
      {...sizeProps}
      className={className}
      viewBox="0 0 512 512"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <defs>
        <linearGradient
          id="syfo-icon-gradient-2"
          x1="64"
          y1="256"
          x2="448"
          y2="256"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#ffb942" stopOpacity="1" />
          <stop offset="1" stopColor="#ff7979" stopOpacity="1" />
        </linearGradient>
        <linearGradient
          id="syfo-icon-gradient-4"
          x1="64"
          y1="256"
          x2="448"
          y2="256"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#e2920b" stopOpacity="1" />
          <stop offset="1" stopColor="#ee4141" stopOpacity="1" />
        </linearGradient>
        <linearGradient
          id="syfo-icon-gradient-51"
          x1="64"
          y1="256"
          x2="448"
          y2="256"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#d79016" stopOpacity="1" />
          <stop offset="1" stopColor="#f05959" stopOpacity="1" />
        </linearGradient>
        <linearGradient
          xlinkHref="#syfo-icon-gradient-2"
          id="syfo-icon-gradient-91"
          x1="64"
          y1="256"
          x2="448"
          y2="256"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(-540.93224,-646.10284)"
        />
        <linearGradient
          xlinkHref="#syfo-icon-gradient-4"
          id="syfo-icon-gradient-92"
          x1="64"
          y1="256"
          x2="448"
          y2="256"
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(0.83333333,0,0,0.37499999,-498.26557,-574.10293)"
        />
        <linearGradient
          xlinkHref="#syfo-icon-gradient-51"
          id="syfo-icon-gradient-93"
          x1="64"
          y1="256"
          x2="448"
          y2="256"
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(0.83333333,0,0,0.37499999,-498.26557,-398.10283)"
        />
      </defs>
      
      {/* Gear-shaped outer border */}
      <path
        fill="#dc4e3a"
        fillOpacity="1"
        d="m 415.00472,80.591462 -21.63311,8.174855 -8.73549,6.441502 -6.40707,7.722791 -19.52756,-13.796257 5.13844,-8.620265 3.15504,-10.384266 0.47857,-23.121189 -12.61081,-5.789067 -17.22103,15.438035 -5.81645,9.161212 -3.1851,9.516972 -23.19343,-5.811218 1.67869,-9.893872 -0.81142,-10.822851 -7.90537,-21.733677 -13.85102,-0.840941 -10.4789,20.615569 -2.11562,10.644976 0.46744,10.024133 -23.72575,2.959062 -2.01005,-9.831703 -4.66478,-9.798636 -15.22273,-17.409831 -13.21965,4.218023 -2.32548,23.009509 1.87391,10.690479 4.05731,9.177419 -21.05565,11.331047 -5.42424,-8.441873 -7.89032,-7.451777 -20.48401,-10.735343 -10.80298,8.709807 6.14322,22.29476 5.60881,9.291743 7.09904,7.09214 -15.54034,18.17164 -8.10774,-5.91265 -10.04947,-4.09919 -22.97793,-2.60958 -6.92814,12.02355 13.78362,18.57025 8.58577,6.63856 9.18126,4.04872 -7.92687,22.55875 -9.6958,-2.58421 -10.85177,-0.1925 -22.370026,5.86746 -2.115789,13.71403 19.560935,12.33707 10.40376,3.08795 10.02451,0.46021 0.75804,23.89755 -9.97526,1.09355 -10.1878,3.74167 -18.740006,13.5507 2.979868,13.5528 22.697058,4.43744 10.81769,-0.87767 9.51358,-3.19348 9.33952,22.01088 -8.90751,4.62317 -8.14779,7.16746 -12.57907,19.40783 7.67564,11.55985 22.76692,-4.06025 9.76898,-4.72803 7.71859,-6.41374 16.65907,17.15046 -6.63515,7.52775 -5.0081,9.62915 -4.71929,22.63952 11.33268,8.0065 19.76212,-12.0105 7.4019,-7.93696 4.88067,-8.76891 21.72957,9.9738 -3.46698,9.4175 -1.1919,10.78681 3.77704,22.81589 13.46063,3.37285 14.09005,-18.339 4.03372,-10.07553 1.38273,-9.93958 23.86683,1.45127 0.16825,10.03351 2.78491,10.49037 11.76506,19.90918 13.76956,-1.71757 6.51299,-22.19043 0.12261,-10.85168 -2.30178,-9.76809 22.77879,-7.26887 3.78176,9.29675 6.38648,8.77418 18.16203,14.31564 12.21865,-6.57578 -1.94169,-23.04516 -3.80526,-10.16241 -5.67476,-8.2772 18.61459,-15.0061 6.88424,7.30133 9.12495,5.87517 22.10658,6.78827 9.01923,-10.54637 -10.13611,-20.78558 -7.21983,-8.10286 -8.28107,-5.668 11.93613,-20.71747 9.05745,4.32173 10.62977,2.18238 23.06734,-1.65749 4.60027,-13.09097 -16.96027,-15.72089 -9.65885,-4.94773 -9.77093,-2.29349 3.6465,-23.63075 10.00693,0.7583 10.70124,-1.80488 20.91114,-9.87716 -0.43971,-13.86931 -21.49353,-8.53347 -10.79543,-1.12351 -9.93811,1.39057 -5.13685,-23.3526 9.60466,-2.9082 9.32764,-5.5482 15.93071,-16.76488 -5.42055,-12.77427 -23.12563,-0.19121 -10.47123,2.85114 -8.76552,4.88622 -13.22454,-19.9189 7.90542,-6.18214 6.69237,-8.54376 8.79877,-21.386321 z m -88.98636,31.310778 -60.87486,71.18223 -90.24647,-16.78591 a 119.85856,119.85856 0 0 1 14.41646,-21.75923 119.85856,119.85856 0 0 1 136.70487,-32.63709 z m 56.50762,48.32519 a 119.85856,119.85856 0 0 1 -11.03079,140.11324 119.85856,119.85856 0 0 1 -19.33639,17.67137 l -30.57566,-86.52291 z m -103.28301,63.29541 0.13593,0.1162 -0.16841,0.0594 z m -27.79961,32.64191 30.36819,85.93069 A 119.85856,119.85856 0 0 1 202.50367,313.53085 119.85856,119.85856 0 0 1 161.97248,239.5236 Z" />
      
      <g transform="matrix(0.84446922,0,0,0.84446922,439.70006,625.42559)">
        {/* Main vault background */}
        <path
          fill="url(#syfo-icon-gradient-91)"
          d="m -412.93226,-582.10289 h 256 c 35.456,0 63.999998,28.544 63.999998,64 v 256 c 0,35.456 -28.543998,64 -63.999998,64 h -256 c -35.456,0 -64,-28.544 -64,-64 v -256 c 0,-35.456 28.544,-64 64,-64 z"
        />
        
        {/* Top vault section */}
        <path
          fill="url(#syfo-icon-gradient-92)"
          d="m -398.00919,-550.10289 h 226.15385 c 25.99538,0 46.92307,21.408 46.92307,48 v 48 c 0,26.592 -20.92769,48 -46.92307,48 h -226.15385 c -25.99539,0 -46.92308,-21.408 -46.92308,-48 v -48 c 0,-26.592 20.92769,-48 46.92308,-48 z"
        />
        
        {/* Bottom vault section */}
        <path
          fill="url(#syfo-icon-gradient-93)"
          d="m -398.00919,-374.10289 h 226.15385 c 25.99538,0 46.92307,21.408 46.92307,48 v 48 c 0,26.592 -20.92769,48 -46.92307,48 h -226.15385 c -25.99539,0 -46.92308,-21.408 -46.92308,-48 v -48 c 0,-26.592 20.92769,-48 46.92308,-48 z"
        />
        
        {/* Vault legs/supports */}
        <path
          fill="#dc4e3a"
          fillOpacity="1"
          d="m -412.93224,-198.10289 v 27.94727 c 0,2.24549 1.68379,4.05273 3.77539,4.05273 h 44.44922 c 2.0916,0 2.9953,-1.98674 3.875,-4.05273 l 11.90039,-27.94727 z m 192,0 11.90039,27.94727 c 0.8797,2.06599 1.7834,4.05273 3.875,4.05273 h 44.44922 c 2.0916,0 3.77539,-1.80724 3.77539,-4.05273 v -27.94727 z"
        />
        
        {/* Top vault handle */}
        <path
          fill="#ffffff"
          d="m -343.41274,-500.84314 v 35 a 10.482048,10.482048 0 0 0 10.4805,10.4805 h 96 a 10.482048,10.482048 0 0 0 10.4805,-10.4805 v -35 h -20.961 v 24.5196 h -75.039 v -24.5196 z"
        />
        
        {/* Bottom vault handle */}
        <path
          fill="#ffffff"
          d="m -343.41271,-324.84314 v 35 a 10.482048,10.482048 0 0 0 10.4805,10.4805 h 96 a 10.482048,10.482048 0 0 0 10.4805,-10.4805 v -35 h -20.961 v 24.5196 h -75.039 v -24.5196 z"
        />
      </g>
    </svg>
  );
};

export default SyfoAdminIcon;
